export function renderNomCode(codeNom: string) {
  var code = codeNom?.split('_')?.[0]
  var nom = codeNom?.replace(`${code}_`, '')
  return [code, nom]
}
